import { useState, useRef } from "react";
import apiRequest from "../../../utils/admin/apiRequest";
import { getFileUrl } from "../../../utils/helper";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";

export default function UploadFavicon() {
  const siteSetting = useSelector((state) => state.globalState.siteSetting);
  const FaviconSrc = getFileUrl(siteSetting?.site_settings?.site_favicon);
  const [image, setImage] = useState(null);
  const [removeBg, setRemoveBg] = useState(false);
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);
  const fileInputRef = useRef(null);

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files?.[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async () => {
    if (!image) return;
    setLoading(true);
    const formData = new FormData();
    formData.append("image", image);
    formData.append("removeBg", String(removeBg));
    apiRequest
      .uploadFavicon({ formData })
      .then((res) => {
        toast.success(res?.data?.message);
        setImage(null);
        setRemoveBg(false);
        setPreview(null);
      })
      .catch((err) => {
        toast.error(String(err?.response?.data?.message || err));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="p-4 bg-white border shadow-sm rounded-2xl">
      <h2 className="mb-3 text-[15px] font-semibold text-gray-700">
        Upload Favicon
      </h2>

      <div
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        onClick={() => fileInputRef.current?.click()}
        className="flex flex-col items-center justify-center w-full p-6 mb-4 border-2 border-dashed cursor-pointer rounded-xl hover:border-primaryDark"
      >
        {preview ? (
          <img
            src={preview}
            alt="Preview"
            className="object-contain w-32 h-32"
          />
        ) : (
          <p className="text-sm text-gray-500">
            Drag & drop Favicon here or click to upload
          </p>
        )}
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="hidden"
        />
      </div>

      {FaviconSrc && (
        <div className="mb-3">
          <p className="mb-1 text-sm text-gray-600">Current Favicon:</p>
          <img
            src={FaviconSrc}
            alt="Current Favicon"
            className="object-contain w-20 h-20 border rounded-md"
          />
        </div>
      )}

      <div className="flex flex-col flex-wrap items-start gap-4 mt-2">
        <label className="flex items-center gap-2 text-sm text-gray-600">
          <input
            type="checkbox"
            checked={removeBg}
            onChange={(e) => setRemoveBg(e.target.checked)}
            className="accent-primaryDark"
          />
          Remove Background
        </label>
        <button
          onClick={handleSubmit}
          disabled={loading || !image}
          className="px-4 py-1.5 text-sm font-medium text-white bg-primaryLight rounded-md hover:bg-primaryDark disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
}
